/**
 * Messages FR des formulaires
 */

module.exports = {

    text: {
        remainingCharacters: '0 caractère restant | 1 caractère restant | { count } caractères restants.'
    },

    select: {
        option: {
            default: 'Sélectionnez une valeur',
            multiple: 'Sélectionnez une ou plusieurs valeurs',
            network: 'Sélectionnez un réseau',
            status: 'Sélectionnez un statut',
            priority: 'Sélectionnez une priorité',
            country: 'Sélectionnez un pays',
            timeZone: 'Sélectionnez un fuseau horaire'
        }
    },

    file: {
        upload: {
            multiple: {
                label: 'Glissez vos fichiers ou cliquez pour sélectionner un fichier'
            },
            unique: {
                label: 'Glissez votre fichier ou cliquez pour uploader'
            }
        },
        extension: {
            help: 'Fichiers autorisés : { types }'
        }
    },

    searching: {
        placeholder: 'Effectuer une recherche...'
    },

    activitySector: {
        select: {
            default: 'Choisissez un secteur d\'activité'
        },
        proposal: {
            button: {
                label: 'Ajouter mon métier/activité',
                altLabel: 'Proposer votre secteur d\'activité si vous ne le trouvé pas.'
            },
            fields: {
                sector: 'Votre proposition de secteur'
            },
            placeholders: {
                sector: 'Médecine, Informatique, ...'
            },
            descriptions: {
                sector: 'Presser la touche ENTREE de votre clavier pour envoyer votre proposition.'
            },
            errors: {
                name: 'Une erreur s\'est produite pendant l\'enregistrement de votre demande.'
            },
            success: 'Votre proposition a été envoyée à l\'administrateur pour être validée. Vous serez alerté de sa décision à l\'adresse { email }.'
        }
    },

    user: {
        editorialLine: {
            fields: {
                editorialLine: 'Ton général de votre ligne éditoriale',
                formality: 'Tutoiement ou vouvoiement ?',
                emoticonType: 'Avec ou sans émoji ?'
            },
            labels: {
                without: 'Sans',
                institutional: 'Modéré',
                emotional: 'Émotionnel'
            },
            hookDescriptions: {
                title: 'Exemple d\'accroche',
                description: {
                    without: 'Les doux rayons du soleil, les jours plus longs et les soirées chaudes - l\'été est là, et avec lui, notre collection de compositions florales estivales qui évoquent la chaleur et la beauté de cette saison enchanteresse. Découvrez notre dernier chef-d\'œuvre floral, "L\'Éclat Estival", un mélange vibrant de marguerites, de tournesols et de lisianthus, soigneusement assemblé pour capturer la magie de l\'été dans chaque pétale. #CompositionEstivale #Fleurs #été #FleuristePassionné #Tournesol.',
                    institutional: 'Les doux rayons du soleil, les jours plus longs et les soirées chaudes 🌞✨ - l\'été est là, et avec lui, notre collection de compositions florales estivales qui évoquent la chaleur et la beauté de cette saison enchanteresse. Découvrez notre dernier chef-d\'œuvre floral, "L\'Éclat Estival", un mélange vibrant de marguerites, de tournesols et de lisianthus, soigneusement assemblé pour capturer la magie de l\'été dans chaque pétale🌻🌿. #CompositionEstivale #Fleurs #été #FleuristePassionné #Tournesol',
                    emotional: 'Les doux rayons du soleil ☀️, les jours plus longs 🌅 et les soirées chaudes 🌙 - l\'été est là, et avec lui, notre collection de compositions florales estivales qui évoquent la chaleur et la beauté de cette saison enchanteresse 🌞✨. Découvrez notre dernier chef-d\'œuvre floral, "L\'Éclat Estival" 🌼, un mélange vibrant de marguerites 🌼, de tournesols 🌻 et de lisianthus 🌸, soigneusement assemblé pour capturer la magie de l\'été dans chaque pétale🌿. #CompositionEstivale #Fleurs #été #FleuristePassionné #Tournesol'
                }
            }
        },
        graphicLine: {
            fields: {
                logo: 'Votre logo',
                files: 'Votre charte graphique',
                addFile: 'Votre charte graphique',
                notDisplayLogoOnGraphicalLineTemplate: 'Ne pas afficher mon logo sur les modèles graphiques'
            },
            defaultTemplatePublication: {
                title: 'Votre modèle graphique par défaut :',
                button: {
                    edit: {
                        label: 'Éditer mon modèle graphique'
                    }
                }
            },
            button: {
                addFile: {
                    label: 'Ajouter un fichier'
                }
            }
        },
        notificationSettings: {
            fieldset: {
                time: {
                    title: 'À quel moment je souhaite être contacté par mon CM au sujet de l’animation de mes comptes social media ?',
                    information: 'Ex: le lundi à 10h00',
                    fields: {
                        dayName: 'Jour de la semaine',
                        time: 'Plage horaire',
                        frequency: 'Fréquence'
                    },
                    frequencies: {
                        weekly: 'Toutes les semaines',
                        fourteenDays: 'Toutes les deux semaines',
                        twentyOneDays: 'Toutes les trois semaines',
                        monthly: 'Une fois par mois'
                    },
                    button: {
                        add: {
                            label: 'Ajouter un créneau'
                        }
                    }
                },
                medium: {
                    title: 'Par quel(s) biais je souhaite être contacté ?',
                    fields: {
                        medium: {
                            email: 'Par email',
                            sms: 'Par SMS',
                            notification: 'Par notification mobile'
                        },
                        email: 'Votre adresse email',
                        phone: 'Votre numéro de téléphone',
                        notification: {
                            information: 'Apparaissent avec les notifications et alertes sur votre téléphone Android'
                        }
                    },
                    notificationType: {
                        cmAdvise: 'Conseils de votre CM',
                        event: 'Rappel d’événement importants',
                        feature: 'Nouveautés et fonctionnalités Tookano',
                        commercialOffer: 'Offres commerciales Tookano'
                    }
                }

            }
        },
        society: {
            fields: {
                societyName: 'Nom société',
                address: 'Adresse société',
                country: 'Pays',
                zipCode: 'Code postal',
                city: 'Ville',
                vatNumber: 'VAT Number'
            }
        }
    },

    admin: {
        // Paramètres pour le Super Admin
        superAdmin: {
            animations: {
                error: 'Une erreur s\'est produite pendant l\'enregistrement des l\'animations.',
                title: 'Animation et vidéo',
                fields: {
                    welcome: 'Animation de bienvenue',
                    presentation: 'Vidéo de présentation'
                }
            },
            configuration: {
                loading: {
                    error: 'Une erreur s\'est produite pendant le chargement de la configuration.'
                },
                taskUrgent: {
                    title: 'Nombre de crédits pour une tâche urgente',
                    error: 'Une erreur s\'est produite pendant la mise à jour de la configuration.',
                    fields: {
                        credits: 'Nombre de crédits'
                    }
                },
                registrationCredits: {
                    title: 'Nombre de crédits offerts à l\'inscription',
                    error: 'Une erreur s\'est produite pendant la mise à jour de la configuration.',
                    fields: {
                        credits: 'Nombre de crédits'
                    }
                },
                aiCredits: {
                    title: 'Crédits de régénération d\'une publication par l\'IA',
                    error: 'Une erreur s\'est produite pendant la mise à jour de la configuration.',
                    fields: {
                        hookCredits: 'Régénération d\'accroche',
                        visualCredits: 'Régénération de visuels'
                    }
                },
                takeMeetUrl: {
                    title: 'Prise de rendez-vous',
                    error: 'Une erreur s\'est produite pendant la mise à jour de la configuration.',
                    fields: {
                        url: 'URL de la prise de rendez-vous'
                    }
                },
                trialPeriodDuration: {
                    title: 'Durée de la période d\'essai',
                    error: 'Une erreur s\'est produite pendant la mise à jour de la configuration.',
                    fields: {
                        duration: 'Durée en jours'
                    }
                },
                userRepositoryFilesMaxSize: {
                    title: 'Taille maximale du répertoire de fichiers d\'un utilisateur',
                    error: 'Une erreur s\'est produite pendant la mise à jour de la configuration.',
                    fields: {
                        size: 'Taille maximale du répertoire de fichiers d\'un utilisateur (en Mo)'
                    }
                },
                maxThematicsGenerations: {
                    title: 'Nombre maximum de générations de thématiques par mois',
                    error: 'Une erreur s\'est produite pendant la mise à jour de la configuration.',
                    fields: {
                        maxGenerations: 'Nombre maximum de générations'
                    }
                }
            },
            translation: {
                title: 'Gestion des traductions',
                error: {
                    default: 'Une erreur s\'est produite pendant le traitement de votre demande.',
                    import: 'Une erreur s\'est produite pendant l\'importation.',
                    export: 'Une erreur s\'est produite pendant l\'exportation.'
                },
                fields: {
                    action: 'Que voulez-vous faire ?',
                    lang: 'Pour quelle langue ?',
                    file: 'Fichier à importer',
                    submit: {
                        import: 'Importer',
                        export: 'Exporter'
                    }
                },
                option: {
                    action: {
                        default: 'Choisissez une action',
                        import: 'Importer un fichier de traduction',
                        export: 'Exporter les traductions'
                    },
                    lang: {
                        default: 'Choisissez une langue'
                    }
                }
            },
            openAITest: {
                error: 'Une erreur s\'est produite pendant le traitement de votre demande.',
                fields: {
                    model: 'Modèle',
                    prompt: 'Prompt',
                    maxTokens : 'Nombre maximum de tokens',
                    number: 'Nombre de choix de la réponse à retourner',
                    temperature: 'Température',
                    imageQuality: 'Qualité de l\'image',
                    verbosity: 'Richesse de la réponse',
                    reasoningEffort: 'Niveau de raisonnement',
                    submit: 'Interroger'
                },
                reasoningEffort: {
                    minimal: 'Donald Trump Mode',
                    none: 'Désactivé',
                    low: 'Bas',
                    medium: 'Moyen (par défaut)',
                    high: 'Haut'
                },
                verbosity: {
                    low: 'Faible',
                    medium: 'Moyenne (par défaut)',
                    high: 'Haute'
                },
                imageQuality: {
                    low: 'Basse',
                    medium: 'Moyenne',
                    high: 'Haute'
                }
            },
            gemini: {
                error: 'Une erreur s\'est produite pendant le traitement de votre demande.',
                fields: {
                    prompt: 'Prompt',
                    imageFormat: 'Format de l\'image',
                    model: 'Modèle',
                    videoDuration: 'Durée de la vidéo',
                    videoResolution: 'Résolution de la vidéo',
                    submit: 'Interroger'
                },
                models: {
                    'gemini-2-5-flash-image': 'Nano Banana',
                    'gemini-3-pro': 'Nano Banana Pro',
                    'gemini-3-1-flash-image': 'Nano Banana 2',
                    'veo-3-1': 'Veo 3.1',
                    'veo-3-1-fast': 'Veo 3.1 Fast'
                },
                videoDuration: '{ duration } secondes',
                imageFormats: {
                    horizontal: 'Paysage',
                    portrait: 'Portrait',
                    square: 'Carré',
                }
            },
            '123rf': {
                error: 'Une erreur s\'est produite pendant le traitement de votre demande.',
                fields: {
                    prompt: 'Prompt',
                    number: 'Nombre d\'images à rechercher',
                    format: 'Format',
                    submit: 'Interroger'
                },
                formats: {
                    horizontal: 'Paysage',
                    portrait: 'Portrait',
                    square: 'Carré',
                    panorama: 'Panorama'
                }
            },
            blackForestLabs: {
                error: 'Une erreur s\'est produite pendant la génération de l\'image.',
                fields: {
                    prompt: 'Prompt',
                    model: 'Modèle',
                    submit: 'Générer',
                    modifyImage: 'Modifier l\'image'
                }
            }
        },

        // Template d'une charte graphique
        graphicalLineTemplate: {
            create: {
                error: 'Une erreur s\'est produite pendant la création du modèle graphique.'
            },
            edit: {
                error: 'Une erreur s\'est produite pendant mise à jour du modèle graphique.',
                fields: {
                    name: 'Nom du modèle graphique',
                    file: 'Image de démo',
                    status: 'Statut',
                    format: 'Format du modèle graphique',
                    thematics: 'Thématiques',
                    isDefault: 'Thème par défaut',
                    position: 'Position',
                    isDefaultSuggestion: 'Suggestion par défaut',
                    theme: 'Thème'
                },
                theme: {
                    placeholder: 'Type de contenu : conseils pratiques, recrutement, étude de cas, concours...'
                },
                templateFileNotSaved: 'L\'image a été modifiée mais n\'a pas été sauvegardée. Cliquez sur le bouton Valider pour enregistrer les modifications.',
                button: {
                    goToTemplateList: {
                        label: 'Gérer mes modèles'
                    }
                },
                addCarouselItemButton: {
                    label: 'Ajouter un élément'
                }
            }
        },

        // Gestion d'un code de promotion
        promotionCode: {
            error: 'Une erreur s\'est produite pendant l\'enregistrement du code de promotion.',
            edit: {
                title: 'Edition du code de promotion { code }'
            },
            fields: {
                alphaCode: 'Code',
                startAt: 'Date de démarrage',
                endAt: 'Date de fin',
                duration: 'Durée de validité',
                activitySectors: 'Secteurs d\'activité',
                promotionAmount: 'Montant de la promotion',
                promotionPercent: 'Pourcentage de la promotion'
            }
        },

        // Gestion des demandes de congés reçus
        requestedHolidays: {
            filters: {
                fields: {
                    searching: 'Rechercher les demandes d\'un agent'
                }
            },
            decline: {
                error: 'Une erreur s\'est produite pendant le refus de la demande.',
                fields: {
                    reason: 'Raison de votre refus'
                }
            }
        },

        // Gestion des packs de crédit
        creditPacks: {
            error: {
                monthly: 'Une erreur s\'est produite pendant la mise à jour de l\'abonnement.',
                unique: 'Une erreur s\'est produite pendant la mise à jour du tarif de crédit.'
            },
            fields: {
                public: 'Visible à tous',
                description: 'Description',
                image: 'Image d\'illustration',
                monthly: {
                    name: 'Nom de l\'abonnement',
                    paymentFrequency: 'Fréquence de paiement',
                    unitPriceWithoutTax: 'Tarif H.T. de l\'abonnement (TVA 20%)',
                    credits: 'Nombre de crédits',
                    maxNetworks: 'Nombre maximum de réseaux',
                    maxPublicationsByWeek: 'Nombre de publications hebdomadaires par réseaux',
                    maxGeneratingTasksIdeasByMonth: 'Nombre maximum de générations d\'idées de tâches par mois',
                    withTasksIdeasRobots: 'Génération d\'idées de tâches à partir des sources',
                    withSubjectsIdeasRobots: 'Génération d\'idées de sujets à partir des sources'
                },
                unique: {
                    name: 'Nom du tarif',
                    unitPriceWithoutTax: 'Tarif H.T.'
                }
            },
            frequency: {
                monthly: 'Mensuelle',
                yearly: 'Annuelle'
            },
            publicId: {
                description: 'Si vous souhaitez filtrer les utilisateurs ou les secteurs d\'activité, il faut décocher cette case.'
            },
            visibility: {
                // Recherche d'éléments qui ne sont pas encore visés par le pack
                searching: {
                    error: 'Une erreur s\'est produite pendant la recherche.',
                    fields: {
                        search: {
                            label: 'Rechercher un utilisateur ou un secteur d\'activité',
                            placeholder: 'Effectuer une recherche'
                        }
                    }
                },
                // Ajout de secteurs ou d'utilisateurs ciblés
                add: {
                    error: 'Une erreur s\'est produite pendant l\'ajout des données',
                    title: 'Résultats de la recherche'
                }
            }
        },

        // Administration des configurations de tâche
        taskConfiguration: {
            error: 'Une erreur s\'est produite pendant la mise à jour de la configuration.',
            fields: {
                name: 'Type de tâche',
                group: 'Groupe',
                credits: 'Valeur en crédits',
                time: 'Temps en minutes',
                image: 'Image d\'illustration',
                emoticon: 'Émoticône'
            },
            group: {
                edit: {
                    error: 'Une erreur s\'est produite pendant la mise à jour du groupe { group }.',
                    fields: {
                        name: 'Nom',
                        parent: 'Groupe parent',
                        image: 'Image d\'illustration',
                        emoticon: 'Émoticône'
                    }
                },
                create: {
                    error: 'Une erreur s\'est produite pendant la création du groupe.'
                },
                taskConfigurations: {
                    add: {
                        title: 'Lier une configuration de tâche',
                        error: 'Une erreur s\'est produite pendant la mise à jour du groupe.',
                        fields: {
                            taskConfiguration: 'Configuration de tâche'
                        }
                    }
                }
            }
        },

        // Administration des vidéos
        video: {
            tutorial: {
                category: {
                    create: {
                        error: 'Une erreur s\'est produite pendant la création de la catégorie.'
                    },
                    edit: {
                        error: 'Une erreur s\'est produite pendant la mise à jour de la catégorie { category }.',
                        fields: {
                            name: 'Nom de la catégorie'
                        }
                    }
                },
                question: {
                    create: {
                        error: 'Une erreur s\'est produite pendant la création de la question.'
                    },
                    edit: {
                        error: 'Une erreur s\'est produite pendant la mise à jour de la question { question }.',
                        fields: {
                            category: 'Catégorie de la question',
                            title: 'Titre de la question',
                            description: 'Description de la question'
                        }
                    }
                },
                video: {
                    create: {
                        error: 'Une erreur s\'est produite pendant la création de la vidéo.'
                    },
                    edit: {
                        error: 'Une erreur s\'est produite pendant la mise à jour de la vidéo { video }.',
                        fields: {
                            question: 'Question de la vidéo',
                            title: 'Titre de la vidéo',
                            description: 'Description de la vidéo',
                            status: 'Statut de la vidéo',
                            url: 'URL de la video'
                        },
                        descriptions: {
                            url: 'URL de la forme : https://www.youtube.com/embed/[video-identifier].'
                        },
                        status: {
                            enabled: 'Activée',
                            disabled: 'Désactivée'
                        }
                    }
                }
            },
            edit: {
                error: 'Une erreur s\'est produite pendant la mise à jour de la vidéo { video }.',
                fields: {
                    title: 'Titre',
                    status: 'Statut',
                    format: 'Format',
                    networks: 'Réseaux',
                    marketingObjectives: 'Objectifs marketing',
                    thematics: 'Thématiques',
                    video: 'Fichier vidéo',
                    preview: 'Image de prévisualisation'
                }
            },
            create: {
                error: 'Une erreur s\'est produite pendant la création de la vidéo.'
            },
            import: {
                error: 'Une erreur s\'est produite pendant l\'importation des vidéos.',
                fields: {
                    file: 'Fichier d\'importation'
                },
                informations: 'Vous pouvez importer un fichier CSV avec les vidéos à intégrer. Un modèle se trouve à cette <a href="{ address }" title="">adresse</a>. La première ligne avec les en-têtes doit être conservée. La deuxième ligne vous décrit les données acceptées pour chaque champ ; elle ne doit pas être présente dans le fichier que vous soumettez.',
            }
        },



        // Administration des idées de publication
        publicationIdea: {
            edit: {
                error: 'Une erreur s\'est produite pendant la mise à jour de l\'idée de publication { idea }.',
            },
            create: {
                error: 'Une erreur s\'est produite pendant la création de l\'idée de publication.'
            },
            import: {
                error: 'Une erreur s\'est produite pendant l\'importation des idées de publication.',
                fields: {
                    file: 'Fichier d\'importation'
                },
                informations: 'Vous pouvez importer un fichier CSV avec les idées de publication à intégrer. Un modèle se trouve à cette <a href="{ address }" title="">adresse</a>. La première ligne avec les en-têtes doit être conservée. La deuxième ligne vous décrit les données acceptées pour chaque champ ; elle ne doit pas être présente dans le fichier que vous soumettez.',
            }
        },

        // Idée de publication et marronnier
        publicationSuggestion: {
            edit: {
                fields: {
                    title: 'Titre',
                    description: 'Description',
                    hook: 'Accroche',
                    status: 'Statut',
                    format: 'Format',
                    networks: 'Réseaux',
                    marketingObjectives: 'Objectifs marketing',
                    thematics: 'Thématiques',
                    preview: 'Image de prévisualisation',
                    publicationsFiles: {
                        list: 'Fichiers de la publication',
                        item: 'Fichier { index }'
                    }
                },
                addPublicationFile: {
                    button: {
                        label: 'Ajouter un fichier de publication'
                    }
                }
            }

        },

        horseChestnutEvent: {
            edit: {
                error: 'Une erreur s\'est produite pendant la mise à jour de l\'événement { event }.',
                fields: {
                    parent: 'Version alternative de l\'événement',
                    publicationDate: 'Date',
                    marketingObjective: 'Objectif marketing',
                    sectorial: 'Filtre du secteur',
                    activitySectors: 'Secteurs d\'activité',
                    credits: 'Nombre de crédits'
                },
                credits: {
                    description: 'Il s\'agit du nombre de crédits nécessaire pour la tâche principale (créa fixe par exemple).'
                },
                sectorial: {
                    universal: 'Universel',
                    sector: 'Sectoriel'
                },
                activitySectors: {
                    default: 'Sélectionner les secteurs d\'activité à filtrer'
                },
            },
            create: {
                error: 'Une erreur s\'est produite pendant la création de l\'événement.'
            },
            import: {
                error: 'Une erreur s\'est produite pendant l\'importation des événements du marronnier.',
                informations: 'Vous pouvez importer un fichier CSV avec les événements du marronnier à intégrer. Un modèle se trouve à cette <a href="{ address }" title="">adresse</a>. La première ligne avec les en-têtes doit être conservée. La deuxième ligne vous décrit les données acceptées pour chaque champ ; elle ne doit pas être présente dans le fichier que vous soumettez.',
                fields: {
                    file: 'Fichier d\'importation'
                }
            }
        },

        // Gestion des permissions
        permission: {
            section: {

                filters: {
                    fields: {
                        searching: 'Rechercher une section par son nom'
                    }
                },
                edit: {
                    error: 'Une erreur s\'est produite pendant la mise à jour de la section { name }.',
                    fields: {
                        key: {
                            label: 'Identifiant unique',
                            description: 'Cet identifiant ne pourra être modifié par la suite.'
                        },
                        name: 'Nom de la section'
                    },
                },
                create: {
                    title: 'Création d\'une nouvelle section de permission',
                    error: 'Une erreur s\'est produite pendant la création de la section.'
                },

                group: {
                    edit: {
                        title: 'Édition du groupe de permissions { name }',
                        error: 'Un erreur s\'est produite pendant la mise à jour du groupe { name }.',
                        fields: {
                            name: 'Nom du groupe de permissions',
                            crud: 'Groupe de permissions CRUD'
                        }
                    },
                    create: {
                        title: 'Création d\'un groupe de permissions pour la section { name }',
                        error: 'Une erreur s\'est produite pendant la création du groupe.'
                    },
                    permission: {
                        edit: {
                            title: 'Édition de la permission { name }',
                            error: 'Une erreur s\'est produite pendant la mise à jour de la permission { name }.',
                            warning: 'Vous devez impérativement créer une permission <em>Accorder</em> à votre groupe de permissions pour qu\'il soit utilisable dans l\'édition de rôle.',
                            fields: {
                                key: {
                                    label: 'Identifiant unique',
                                    description: 'Cet identifiant ne pourra être modifié par la suite. Il est utilisé pour vérifier qu\'un rôle possède cette permission.'
                                },
                                name: 'Nom de la permission',
                                type: 'Type de permission',
                            }
                        },
                        create: {
                            title: 'Création d\'une nouvelle permission pour le groupe { name }',
                            error: 'Une erreur s\'est produite pendant la création de la permission.'
                        }
                    }
                }

            }
        },

        // Gestion des rôles
        role: {
            filters: {
                fields: {
                    searching: 'Rechercher un rôle par son nom'
                }
            },
            edit: {
                error: 'Une erreur s\'est produite pendant la mise à jour du rôle { name }.',
                fields: {
                    name: 'Nom du rôle'
                },
            },
            create: {
                error: 'Une erreur s\'est produite pendant la création du rôle.'
            }
        },

        // Personnalisation de l'application
        application: {
            current: {
                edit: {
                    genericError: 'Une erreur s\'est produite pendant la mise à jour de l\'application.',
                    fields: {
                        name: 'Nom de l\'interface',
                        domain: 'Nom de domaine',
                        logo: 'Logo de l\'application',
                        favoriteIcon: 'Icône de favori',
                        termsOfUse: 'Conditions générales d\'utilisation',
                        privacyPolicy: 'Politique de confidentialité',

                        privacyPolicyHtml: 'Politique de confidentialité HTML { lang }'
                    }
                }
            }
        },

        // Gestion des mails internes
        mail: {
            filters: {
                fields: {
                    searching: 'Rechercher un mail par nom'
                }
            },
            edit: {
                title: 'Édition de l\'email { name }',
                genericError: 'Une erreur s\'est produite pendant la mise à jour du mail { name }.',
                fields: {
                    name: 'Nom de l\'email',
                    lang: 'Langue',
                    contents: 'Contenu de l\'email'
                }
            }
        },

        // Liste des contacts
        contact: {
            filters: {
                fields: {
                    searching: 'Rechercher un contact par son nom ou son adresse email'
                },
            },
            edit: {
                title: 'Édition du contact { name }',
                genericError: 'Une erreur s\'est produite pendant la mise à jour du compte de { name }.',
                fields: {
                    firstName: 'Prénom',
                    lastName: 'Nom',
                    email: 'Adresse email',
                    role: 'Rôle'
                }
            },
            create: {
                title: 'Ajout d\'un contact à votre compte',
                genericError: 'Une erreur s\'est produite pendant la création du compte.'
            }
        },

        // Gestion des secteurs d'activités
        activitySector: {
            filters: {
                fields: {
                    searching: 'Rechercher un secteur d\'activité par son nom'
                },
            },
            edit: {
                title: 'Édition du secteur d\'activité { name }',
                error: 'Une erreur s\'est produite pendant la mise à jour du secteur { name }.',
                fields: {
                    name: 'Nom du secteur',
                    lang: 'Langue',
                    parent: 'Secteur parent',
                    acceptProposal: 'Accepter la proposition',
                    aiSettings: {
                        editorialLine: 'Ton de la ligne éditoriale',
                        writingStyle: {
                            formality: 'Tutoiement / Vouvoiement',
                            pronouns: 'Pronoms',
                            languageRegister: 'Registre de langue',
                            tones: 'Tons'
                        },
                        contents: {
                            post: 'Exemple de publication de type { postType }',
                            prompt: 'Prompt du style rédactionnel pour les publication de type { postType }'
                        },
                        thematic: {
                            name: 'Nom de la thématique { position }',
                            subject: 'Sujet { position } de la thématique { thematic }'
                        }
                    }
                },
                fieldset: {
                    contentsByLang: 'Contenus { lang }',
                    posts: 'Post de type { postType }',
                    thematicsByLang: 'Thématiques { lang }',
                    thematicsSubjects: 'Sujets de publications de la thématique'
                },
                button: {
                    addThematic: {
                        label: 'Ajouter une thématique'
                    },
                    addSubject: {
                        label: 'Ajouter un sujet'
                    },
                    removeThematic: {
                        altLabel: 'Supprimer la thématique.'
                    },
                    removeSubject: {
                        altLabel: 'Supprimer le sujet.'
                    }
                }
            },
            create: {
                title: 'Ajout d\'un secteur d\'activité',
                error: 'Une erreur s\'est produite pendant la création du secteur d\'activité.'
            }
        },

        // Gestion des messages de désabonnement
        unsubscribeMessages: {
            edit: {
                title: 'Mise à jour du message { message }',
                error: 'Une erreur s\'est produite pendant la mise à jour du message.',
                fields: {
                    message: 'Message',
                    type: 'Type',
                    enabled: 'Actif',
                    emoticon: 'Icône'
                },
                type: {
                    unique: 'Radio',
                    multiple: 'Choix multiple',
                    free: 'Champ libre'
                },
                answers: {
                    title: 'Sous-réponse { position }',
                    button: {
                        add: {
                            label: 'Ajouter une sous-réponse',
                            altLabel: 'Ajouter une réponse sélectionnable à l\'utilisateur'
                        }
                    },
                    countAnswered: 'Aucune réponse | 1 réponse | { count } réponses'
                }
            },
            create: {
                title: 'Ajout d\'un message de désabonnement',
                error: 'Une erreur s\'est produite pendant la création du message.'
            },
        },

        // Gestion des utilisateurs
        users: {
            filters: {
                internalAgent: {
                    fields: {
                        searching: 'Rechercher un agent interne'
                    }
                },
                externalAgent: {
                    fields: {
                        searching: 'Rechercher un agent externe'
                    }
                },
                teamManager: {
                    fields: {
                        searching: 'Rechercher un manager'
                    }
                },
                productManager: {
                    fields: {
                        searching: 'Rechercher un chef de produit'
                    }
                },
                customer: {
                    fields: {
                        searching: 'Rechercher un client'
                    }
                }
            },
            planning: {
                error: 'Une erreur s\'est produite pendant la mise à jour du planning de { name }.',
                fieldsets: {
                    workingDays: {
                        title: 'Jours ouvrables',
                        tooHours: 'La durée de présence est supérieure à la durée hebdomadaire renseignée.'
                    },
                    nonWorkingDays: {
                        title: 'Jours non ouvrables',
                        fields: {
                            name: 'Nom *',
                            date: 'Date *'
                        },
                        addButton: {
                            label: 'Ajouter un jour non ouvrable'
                        }
                    }
                }
            },
            fields: {
                freeSubscriptionUntil: 'Date avant qu\'un abonnement soit nécessaire',
                firstName: 'Prénom',
                lastName: 'Nom',
                profileImage: 'Image de profil',
                email: 'Adresse email',
                registeredAt: 'Date d\'inscription',
                phone: 'Numéro de téléphone',
                applicationLang: 'Langue de l\'interface',
                languages: 'Langues parlées',
                role: 'Rôle',
                isTestAccount: 'Il s\'agit d\'un compte test',
                subscriptionType: 'Type d\'abonnement',
                contract: {
                    type: 'Type de contrat',
                    start: 'Début du contrat',
                    end: 'Fin de contrat',
                    weeklyHours: 'Durée hebdomadaire',
                    nbHolidays: 'Nombre de jours de congés',
                    productivity: 'Taux de productivité quotidien',
                },
                society: {
                    name: 'Nom de la société',
                    summary: 'Résumé de l\'activité',
                    workforce: 'Nombre de personnes dans la société',
                    activityType: 'Type d\'activité',
                    siteUrl: 'Lien vers site internet',
                },
                settings: {
                    editorialLine: 'Le ton général de votre ligne éditoriale',
                    formality: 'Tutoiement / Vouvoiement',
                    emoticonType: 'Type d\'émoji'
                },
                credits: {
                    free: 'Nombre de crédits'
                }
            },
            tabMenu: {
                customer: {
                    basic: 'Informations essentielles',
                    editorialGraphicLine: 'Ligne éditoriale et graphique',
                    notifications: 'Communication'
                }
            },
            languages: {
                fr: 'Français',
                en: 'Anglais',
                es: 'Espagnol',
                de: 'Allemand'
            },
            updateRole: {
                error: 'Une erreur s\'est produite pendant la mise à jour du rôle.',
            },
            internalAgent: {
                fields: {
                    code: 'Code agent'
                },
                create: {
                    error: 'Une erreur s\'est produite pendant la création de l\'agent interne.'
                },
                edit: {
                    error: 'Une erreur s\'est produite pendant la mise à jour de l\'agent interne { name }.'
                }
            },
            externalAgent: {
                fields: {
                    code: 'Code agent'
                },
                create: {
                    error: 'Une erreur s\'est produite pendant la création de l\'agent externe.'
                },
                edit: {
                    error: 'Une erreur s\'est produite pendant la mise à jour de l\'agent externe { name }.'
                }
            },
            teamManager: {
                fields: {
                    code: 'Code manager',
                    agents: {
                        label: 'Agents reliés',
                        placeholder: 'Rechercher un agent à rattacher au manager'
                    }
                },
                create: {
                    error: 'Une erreur s\'est produite pendant la création du manager.'
                },
                edit: {
                    error: 'Une erreur s\'est produite pendant la mise à jour du manager { name }.'
                }
            },
            productManager: {
                fields: {
                    code: 'Code chef de produit'
                },
                create: {
                    error: 'Une erreur s\'est produite pendant la création du chef de produit.'
                },
                edit: {
                    error: 'Une erreur s\'est produite pendant la mise à jour du chef de produit { name }.'
                }
            },
            customer: {
                fields: {
                    code: 'Code client',
                    agent: {
                        label: 'Affecter un agent',
                        placeholder: 'Rechercher un agent à affecter'
                    },
                    sector: 'Secteur d\'activité et métier'
                },
                create: {
                    error: 'Une erreur s\'est produite pendant la création du client.'
                },
                edit: {
                    error: 'Une erreur s\'est produite pendant la mise à jour du client { name }.'
                },
                button: {
                    goToEditorialGraphicLine: {
                        label: 'Passer à la ligne'
                    },
                    goToNotifications: {
                        label: 'Passer à la communication'
                    }
                }
            },
        },

        // Gestion des offres de coaching
        coachingOffers: {
            filters: {
                fields: {
                    searching: 'Rechercher une offre de coaching'
                }
            },
            create: {
                error: 'Une erreur s\'est produite pendant la création de l\'offre.'
            },
            edit: {
                error: 'Une erreur s\'est produite pendant la mise à jour de l\'offre { name }.',
                fields: {
                    name: 'Nom',
                    image: 'Image',
                    summary: 'Résumé',
                    details: 'Détail de la prestation',
                    duration: 'Durée de la prestation',
                    credits: 'Tarif en crédits'
                }
            }
        }
    },

    publicationSuggestion: {
        filter: {
            format: 'Filtrer un format',
            network: 'Filtrer un réseau',
            thematic: 'Filtrer la thématique',
            status: 'Filtrer le statut',
            marketingObjective: 'Filtrer l\'objectif marketing'
        }
    },

    requestHolidays: {
        error: 'Une erreur s\'est produite pendant l\'envoi de votre demande.',
        fields: {
            type: 'Type de congés *',
            begin: 'Date de début *',
            end: 'Date de fin *',
        }
    },

    account: {
        edit: {
            error: 'Une erreur s\'est produite pendant la mise à jour de votre compte.',
            menu: {
                tabs: {
                    informations: {
                        label: 'Informations essentielles'
                    },
                    settings: {
                        label: 'Ligne éditoriale et graphique'
                    },
                    notifications: {
                        label: 'Notifications'
                    }
                }
            },
            informations: {
                fields: {
                    profileImage: 'Image de profil',
                    lastName: 'Nom',
                    firstName: 'Prénom',
                    email: 'Adresse email',
                    phone: 'Numéro de téléphone',
                    sector: 'Secteur',
                    password: 'Mot de passe',
                    spokenLanguages: 'Langues parlées',
                    registrationDate: 'Inscription',
                    timeZone: 'Fuseau horaire',

                    trialPeriodRemainingTimeDisplayed: 'Afficher le temps restant de la période d\'essai',

                    society: {
                        name: 'Nom de l\'établissement',
                        summary: 'Résumé de l\'activité',
                        workforce: 'Nombre de personne',
                        activityType: 'Type d\'activité',
                        siteUrl: 'Site internet'
                    }
                },
                changePasswordButton: {
                    label: 'Réinitialisation du mot de passe'
                },
                credits: {
                    counter: '{ count } crédit | { count } crédit | { count } credits',
                    add: {
                        altLabel: 'Obtenir plus de crédits'
                    }
                }
            }
        },
        registration: {

            completion: {
                canNotFoundDefaultSubscription: 'Impossible de déterminer les paramètres de la période d\'essai.',
                error: 'Une erreur s\'est produite pendant le traitement de vos informations.',
                paymentMethodError: 'Nous n\'avons pas pu valider vos données bancaires.',
                fields: {
                    societyName: 'Nom de la société',
                    activitySector: 'Secteur d\'activité',
                    network: 'Réseau social à gérer',
                    activitySummary: 'Résumé de l\'activité',
                    activityType: 'Type d\'activité'
                },
                descriptions: {
                    activitySummary: 'Vous avez la possibilité d\'ajouter des informations complémentaires ou de modifier le résumé à votre guise. Le but de ce résumé permettra à l\'IA de cerner votre activité, la manière de s’exprimer, etc... Pour mieux définir votre ligne éditorial qui sera utiliser pour votre communication.'
                },
                trialPeriodInformations: {
                    title: 'Essai 100% gratuit pendant { duration }',
                    underTitle: '🆓 Gratuit · 🔓 Sans engagement · ↩️ Résiliable à tout moment',
                    duration: '{ duration } d\'utilisation',
                    nbPublications: 'Jusqu\'à 0 post publié par mois | Jusqu\'à 1 post publié par mois | Jusqu\'à { count } posts publiés par mois',
                    nbAdditionalGenerations: 'Jusqu\'à 0 idée de post généré par mois | Jusqu\'à 1 idée de post généré par mois | Jusqu\'à { count } idées de posts générées par mois',
                    networks: '0 réseau social au choix | 1 réseau social au choix | { count } réseaux sociaux au choix',
                    about: {
                        line1: 'Ajoutez vos propres posts depuis votre contenu, une URL, un prompt ou une image.',
                        line2: 'Créez et programmez vos visuels grâce à l\'éditeur graphique et aux modèles personnalisables.',
                        line3: 'Votre période d\'essai est valable { duration }, elle permet de comprendre si l\'utilisation que vous souhaitez avoir d\'un outil comme Tookano s\'adapte parfaitement à votre environnement.'
                    }
                },
                trialPeriodBillingInformations: {
                    title: 'Conditions de votre période d’essai',
                    rule1: '🚫 Aucun débit pendant votre période d\'essai.',
                    rule2: '🔔 Un mail de rappel vous est envoyé 7 jours avant la fin (avec le planning éditorial du mois suivant).',
                    rule3: '💳 Sans action de votre part, <strong>l\'abonnement { productName }</strong> démarre automatiquement <strong>à { subscriptionPrice }/HT/mois</strong>, résiliable à tout moment, sans engagement.',
                    why: 'Cette période d\'essai est un moyen pour nous d\'identifier une IA ou non, la création d’un compte de manière automatisé est pour nous une réel contrainte que nous souhaitons éviter.'
                },
                buttons: {
                    takeMeet: {
                        label: 'Je veux une Démo avant'
                    },
                    submit: {
                        label: 'Je démarre ma période d\'essai'
                    }
                }
            },
        },
        contactsInformations: {
            error: 'Une erreur s\'est produite pendant la mise à jour de vos informations.',
            title: 'Souhaitez-vous être alerté ?',
            fields: {
                email: 'Adresse e-mail',
                phone: 'Num tel (pour être alerté par SMS)'
            }
        },
        resetPassword: {
            error: 'Une erreur s\'est produite pendant la réinitialisation de votre mot de passe.',
            fields: {
                currentPassword: 'Mot de passe actuel',
                newPassword: 'Nouveau mot de passe',
                confirmPassword: 'Confirmation du nouveau mot de passe'
            }
        },
        ai: {
            validationData: {
                error: 'Une erreur s\'est produite pendant l\'enregistrement des données.',
                loadingResources: {
                    error: 'Une erreur s\'est produite pendant le chargement des données.'
                },
                menu: {
                    subjects: 'Sujets et objectifs associés',
                    generic: 'Paramètres généraux',
                    events: 'Posts spécifiques',
                    aiSettings: 'Paramètres IA',
                    analysis: 'Personnalisation des posts'
                },
                fields: {
                    logo: 'Votre logo',
                    colors: 'Vos couleurs dominantes',
                    fonts: 'Vos typographies',
                    networks: 'Choisissez 1 réseau social',
                    commercialName: 'Nom commercial',
                    sector: 'Métier',
                    activitySummary: 'Résumé de l\'activité',
                    activityType: 'Type d\'activité',

                    events: {
                        title: 'Générez un post à partir du contenu d\'une url',
                        productUrl: 'Indiquez l\'url de la page web',
                        eventUrl: 'URL de votre évènement',
                        name: 'Nom',
                        eventDate: 'Date de l\'événement',
                        publicationDate: 'Date de publication'
                    },

                    audiences: {
                        name: 'Nom de la cible',
                        description: 'Description de la cible'
                    }

                },

                analysis: {
                    description: 'Pour encore plus de personnalisation de vos posts, indiquez-nous',
                    fieldsets: {
                        sources: {
                            title: 'Pour automatiser la création de vos posts'
                        },
                        taskIdeasSources: {
                            title: 'Repost',
                            description: 'Indiquez l\'url de votre blog, page d\'actualités, catalogue produits, annonces immobilières... Tookano récupérera automatiquement le dernier article, annonce ou événement paru sur cette url et créera un post pour chaque nouvelle actualité.'
                        },
                        notifications: {
                            title: 'Gérer la fréquence de ma veille',
                            timeTitle: 'À quel moment je souhaite être contacté pour recevoir ma veille ?'
                        },
                        taskSubjectsSources: {
                            title: 'Veille',
                            description: 'En indiquant les urls ci-dessous, Tookano récupérera les dernières informations parues sur ces sources et vous avertira à la fréquence de votre choix'
                        },
                        dataUrlList: {
                            title: 'Pour des thématiques et des sujets plus précis sur votre activité'
                        },
                        writingStyle: {
                            title: 'Pour une écriture qui vous ressemble'
                        },
                        postImages: {
                            title: 'Des posts basés sur vos images',
                            description: 'Téléchargez vos propres images afin de créer des posts personnalisés. Elles seront utilisées en priorité si le sujet d\'un post correspond à l\'une d\'entre elles. Cela vous fera gagner beaucoup de temps. Vous pouvez télécharger jusqu\'à 10 images.',
                            addImageButton: {
                                label: 'Ajouter une image'
                            }
                        }
                    },

                    titles: {
                        events: 'Analyse de vos actualités / événements'
                    },

                    fieldDescriptions: {
                        postsAccountUrl: 'Entrez l\'url de votre compte ou d\'un compte qui vous inspire',
                        productsUrl: 'Entrez l\'url de votre flux de produits',
                        writingStyleUrl: 'Entrez l\'url de votre compte, d\'un post ou d\'un compte / post qui vous inspire'
                    },
                    fields: {
                        postsAccountUrl: 'Analyse de votre compte { network }',
                        eventsUrl: 'URL de votre blog',
                        actualitiesSectorUrl: 'Souhaitez-vous ajouter une source d\'actualité sur votre secteur d\'activité ?',
                        eventsXMLUrl: 'URL de votre flux rss',
                        productsUrl: 'Analyse de vos produits',
                        writingStyleUrl: 'Analyse du style rédactionnel de votre compte { network }',
                        postImage: 'Image { index }',
                        taskIdeaSource: 'Url de la source',
                        taskSubjectSource: 'Url de la source { position }'
                    },
                    maxSources: 'Il n\'est possible d\'ajouter que { count } sources de contenu pour le moment.',
                    button: {
                        selectActualitiesSectorUrl: {
                            label: 'Sélectionner'
                        }
                    },

                    errors: {
                        productsUrl: 'Une erreur s\'est produite pendant l\'analyse des produits. Assurez vous que votre adresse redirige bien vers un fichier au format XML.',
                        eventsXMLUrl: 'Une erreur s\'est produite pendant l\'analyse des articles. Assurez vous que votre adresse redirige bien vers un fichier au format XML.',
                        actualitiesSectorUrl: 'Une erreur s\'est produite pendant l\'analyses des actualités.'
                    }
                },

                defineProductsSchema: {
                    error: 'Une erreur s\'est produite pendant le traitement des données.',
                    types: {
                        id: 'Identifiant du produit',
                        name: 'Nom du produit',
                        description: 'Description du produit',
                        url: 'URL du produit',
                        imageUrl: 'URL de l\'image',
                        price: 'Prix du produit',
                        weight: 'Poids du produit'
                    }
                },

                products: {
                    item: {
                        title: 'Produit / Service / Actualité / Événement { position }'
                    }
                },
                events: {
                    item: {
                        title: 'Événement { position }'
                    }
                },
                descriptions: {
                    activitySummary: 'Assurez-vous que votre acheteur cible (persona) soit bien mentionné (ex : Nos personas cibles sont les directeurs marketing et communication de sociétés innovantes qui conçoivent des produits industriels et médicaux. / Notre persona cible est le particulier, CSP+ de 29 à 44 ans, situé à Bordeaux et ses alentours). <br />Assurez-vous de la précision des descriptions de vos services / produits / solutions.',
                    sector: 'Ajoutez au moins 3 lettres pour initier votre recherche.',
                    network: 'Choisissez un réseau social pour votre planning gratuit (vous pourrez utiliser les autres ultérieurement).'
                },
                titles: {
                    events: 'Souhaitez-vous voir apparaitre des posts spécifiques ?',
                    audiences: 'Cibles de vos réseaux sociaux'
                },

                audiences: {
                    item: {
                        title: 'Cible { position }'
                    },
                    addButton: {
                        label: 'Ajouter une cible'
                    },
                    generateButton: {
                        label: 'Générer mes cibles'
                    }
                },

                buttons: {
                    colors: {
                        add: {
                            label: 'Ajouter une couleur'
                        }
                    },
                    fonts: {
                        add: {
                            label: 'Ajouter une police'
                        }
                    },
                    products: {
                        add: {
                            label: 'Ajoutez une autre url'
                        }
                    },
                    events: {
                        add: {
                            label: 'Ajouter un événement'
                        }
                    }
                }
            },
            validationSubjects: {
                error: 'Une erreur s\'est produite pendant l\'enregistrement des données.',
                fields: {
                    name: 'Titre',
                    description: 'Description du sujet',
                    tone: 'Ton à adopter',
                    marketingObjective: 'Objectif associé',
                    publicationDate: 'Date de publication',
                    aiThematic: 'Thématique',
                    aiAudience: 'Cible',
                    format: 'Format'
                },
                formats: {
                    image: 'Image',
                    carousel: 'Carrousel'
                },
                period: {
                    display: 'Voir les sujets du mois de { month } { year }',
                    hide: 'Réduire les sujets du mois de { month } { year }'
                },
                fieldset: {
                    subject: {
                        title: 'Sujet du post { index }'
                    }
                },
                description: {
                    empty: 'Indiquez plus précisément le contenu de votre sujet.'
                },
                templates: {
                    label: 'Charte pour la publication',
                    goToTemplateList: {
                        label: 'Gérer mes chartes',
                    },
                    choiceAnotherTemplate: {
                        withSelected: {
                            title: 'Choisir une autre charte ?'
                        },
                        withoutSelection: {
                            title: 'Quelle charte voulez-vous utiliser ?'
                        }
                    }
                },
                button: {
                    add: {
                        label: 'Ajouter un sujet'
                    },
                    remove: {
                        label: 'Supprimer le sujet'
                    },
                    templates: {
                        choiceTemplate: {
                            label: 'Choisir une charte'
                        },
                        choiceAnotherTemplate: {
                            label: 'Choisir une autre charte'
                        },
                        selectTemplate: {
                            altLabel: 'Utiliser cette charte.'
                        }
                    }
                }
            },
            settings: {
                error: 'Une erreur s\'est produite pendant l\'enregistrement de vos paramètres.',
                fieldset: {
                    editorialLine: {
                        title: 'La ligne éditoriale',
                        fields: {
                            categories: 'Catégories',
                            values: 'Valeurs',
                            format: 'Format',
                            editorialLine: 'Ton',
                            emoticon: 'Avec ou sans émoji ?'
                        },
                        button: {
                            addValue: {
                                label: 'Ajouter une valeur'
                            },
                            addCategory: {
                                label: 'Ajouter une thématique'
                            }
                        }
                    },
                    graph: {
                        title: 'La ligne graphique',
                        fields: {
                            logo: 'Votre logo',
                            colors: 'Vos couleurs dominantes',
                            fonts: 'Vos typographies'
                        }
                    },
                    contents: {
                        title: 'Personnalisation des posts',
                        fields: {
                            taskIdeaSource: 'Source repost',
                            subjectIdeaSource: 'Source veille { index }',
                            postsAccountUrl: 'Analyse de votre compte',
                            eventsUrl: 'Analyse de vos actualités / événements',
                            productsUrl: 'Analyse de vos produits',
                            actualitiesSectorUrl: 'Source d\'actualité de votre secteur d\'activité'
                        },
                        descriptions: {
                            postsAccountUrl: 'Entrez l\'url de votre compte ou d\'un compte qui vous inspire',
                            eventsUrl: 'Entrez l\'url de votre blog, actualités sous le format XML comme par exemple https://www.nomdedomaine.com/blog/feed',
                            productsUrl: 'Entrez l\'url de votre flux de produits au format XML',
                            actualitiesSectorUrl: 'Indiquez une url qui renvoie vers un flux rss d\'une source de contenu type : https://www.nomdedomaine.com/actualites/feed'
                        },
                        withProblemGeneratingSubjectSourceUrl: 'Nous avons rencontré un problème à la récupération des sujets sur cette source'
                    },
                    writingStyle: {
                        title: 'Style rédactionnel',
                        fields: {
                            writingStyleUrl: 'Pour une écriture qui vous ressemble'
                        },
                        descriptions: {
                            writingStyleUrl: 'Entrez l\'url de votre compte, d\'un post ou d\'un compte / post qui vous inspire'
                        }
                    },
                    networks: {
                        title: 'Réseaux et fréquence',
                        frequency: '{ count } posts / semaine'
                    },
                    aiNetworkThematics: {
                        title: 'Mes thématiques éditoriales',
                        edit: {
                            error: 'Une erreur s\'est produite pendant la mise à jour de la thématique.',
                            descriptions: {
                                name: 'Presser la touche ENTREE de votre clavier pour mettre à jour la thématique.',
                                subjectsProposals: 'Faites une sélection des sujets pertinents pour votre activité ou ajoutez ceux de votre choix'
                            },
                            placeholders: {
                                subjectProposal: {
                                    name: 'Indiquez un sujet de votre choix',
                                    customerPrompt: 'Génère 5 nouveaux sujets sur cette thématique en prenant en compte les éléments suivants (indiquez votre demande)'
                                }
                            },
                            fields: {
                                subjectsProposals: {
                                    customerPrompt: 'Demandez à l\'IA de générer de nouveaux sujets en lui donnant un maximum de précisions techniques sur les spécificités de votre activité'
                                }
                            },
                            button: {
                                subjectsProposals: {
                                    generate: 'Générer'
                                }
                            }
                        },
                        add: {
                            error: 'Une erreur s\'est produite pendant l\'ajout de la thématique.',
                            button: {
                                label: 'Ajouter une thématique'
                            },
                            fields: {
                                name: 'Nom de la thématique'
                            },
                            descriptions: {
                                name: 'Presser la touche ENTREE de votre clavier pour ajouter la thématique.'
                            }
                        }
                    },

                    aiNetworkAudiences: {
                        fields: {
                            name: 'Nom de la cible',
                            description: 'Description de la cible'
                        },
                        add: {
                            error: 'Une erreur s\'est produite pendant l\'ajout de la cible.',
                            button: {
                                label: 'Ajouter une cible'
                            },
                        },
                        edit: {
                            error: 'Une erreur s\'est produite pendant la mise à jour de la cible.',
                            title: 'Cible { position }',
                            save: {
                                altLabel: 'Enregistrer la cible.'
                            }
                        }
                    },

                    targeting: {
                        title: 'La cible',
                        fields: {
                            description: 'Description',
                            locations: 'Rayonnement'
                        },
                        location: {
                            placeholder: 'Pays, région ou ville'
                        }
                    },
                    society: {
                        title: 'Société',
                        fields: {
                            activitySummary: 'Résumé de l\'activité'
                        }
                    }
                },
                aiNetwork: {
                    fields: {
                        tone: 'Ton',
                        customTone: 'Ton personnalisé'
                    },
                    placeholders: {
                        customTone: 'Ex : à la façon de Baudelaire, rédige en créole, ou copier/coller un texte d\'inspiration'
                    },
                    button: {
                        editCustomTone: {
                            altLabel: 'Editer le ton personnalisé pour le réseau { network }.'
                        }
                    }
                }
            },
            editPostImage: {
                error: 'Une erreur s\'est produite pendant la mise à jour de l\'image.',
                fields: {
                    title: 'Titre',
                    description: 'Description',
                    file: 'Fichier'
                }
            },
            addPostImages: {
                error: 'Une erreur s\'est produite pendant l\'enregistrement.',
                fields: {
                    network: 'Réseau',
                    postImage: 'Image { index }'
                },
                addImageButton: {
                    label: 'Ajouter une image'
                }
            },

            generateNewIdeasSettings: {
                error: 'Une erreur s\'est produite pendant l\'enregistrement des données.'
            }
        },
        statistics: {
            publications: {
                recommendations: {
                    title: 'Quel(s) objectif(s) (3 maximum) souhaitez-vous atteindre : chiffrés ou non',
                    error: 'Une erreur s\'est produite pendant le traitement des données.',
                    fields: {
                        followers: 'Augmenter le nombre de followers',
                        engagement: 'Augmenter le taux d\'engagement',
                        views: 'Augmenter les vues',
                        subjects: 'Varier les sujets'
                    }
                }
            },
            social: {
                accounts: {
                    period: {
                        start: 'Date de début',
                        end: 'Date de fin'
                    }
                }
            }
        },
        graphicalLineTemplate: {
            edit: {
                error: 'Une erreur s\'est produite dans l\'enregistrement de la charte graphique.',
                templateFileNotSaved: 'L\'image a été modifiée mais n\'a pas été sauvegardée. Cliquez sur le bouton Valider pour enregistrer les modifications.',
                fields: {
                    name: 'Nom de la charte',
                    thematics: 'Thématiques'
                }
            }
        },

        font: {
            add: {
                error: 'Une erreur s\'est produite pendant l\'ajout de la police.',
                fields: {
                    name: 'Nom de la police',
                    file: 'Fichier source',
                },
                fieldset: {
                    files: {
                        title: 'Fichier { position }'
                    }
                },
                button: {
                    addSourceFile: {
                        label: 'Ajouter un fichier source'
                    },
                    removeSourceFile: {
                        altLabel: 'Supprimer ce fichier.'
                    }
                }
            }
        },

        themes: {
            list: {
                editListButton: {
                    label: 'Gérer les thèmes'
                }
            },
            edit: {
                error: 'Une erreur s\'est produite pendant la mise à jour du thème.',
                fields: {
                    name: 'Nom',
                    description: 'Description'
                }
            },
            create: {
                error: 'Une erreur s\'est produite pendant la création du thème.'
            },
            addButton: {
                label: 'Ajouter un thème'
            }
        },
        visualIdentity: {
            error: 'Une erreur s\'est produite pendant l\'enregistrement des données.',
            emptyFont: 'Aucune police n\'a été trouvée.',
            fields: {
                fonts: 'Vos typographies'
            },
            button: {
                addFont: {
                    altLabel: 'Ajouter une police.'
                }
            },
            graphicalLineTemplatesByCategory: {
                updateDefaultTemplatesError: 'Une erreur s\'est produite lors de la mise à jour des paramètres.',
                categories: {
                    informational: 'Informationnel',
                    advice: 'Conseil',
                    promotional: 'Promotionnel'
                },
                manageButton: {
                    altLabel: 'Gérer les modèles graphiques par défaut des publications de type { category }.',
                }
            }
        },
        postsSettings: {
            loadResourcesError: 'Une erreur s\'est produite lors du chargement des données.',
            error: 'Une erreur s\'est produite pendant l\'enregistrement des paramètres.',
            tabMenu: {
                global: {
                    altLabel: 'Personnalisation globale'
                }
            },
            global: {
                title: 'Personnalisation globale',
                sources: {
                    title: 'Pour des posts + personnalisés'
                },
                repositoryFiles: {
                    title: 'Ajouter vos documents PDF',
                    description: 'Ajoutez vos documents pour que l\'IA puisse mieux comprendre votre activité, vos produits, vos services.',
                    uploadError: 'Une erreur s\'est produite lors du traitement du fichier.',
                    removeError: 'Une erreur s\'est produite lors de la suppression du fichier.',
                    legal: 'En utilisant cette fonctionnalité, vous déclarez être propriétaire des fichiers et acceptez qu\'ils soient utilisés par des IA pour générer des contenus.',
                    empty: 'Vous n\'avez pas ajouté de fichier.'
                }
            },
            network: {
                title: 'Personnalisation { network }',
                fields: {
                    defaultPostType: 'Type de post par défaut',
                    formality: 'Tutoiement / Vouvoiement'
                },
                defaultPostTypes: {
                    singleImage: 'Fixe',
                    carousel: 'Carrousel',
                    undefined: 'Mix'
                },
                subjectsByWeek: {
                    title: 'Fréquence du réseau'
                },
                rulesContents: {
                    title: 'Vos règles de contenu',
                    fields: {
                        rule: 'Règle { position }'
                    },
                    button: {
                        add: {
                            altLabel: 'Ajouter une règle de contenu pour le réseau { network }.'
                        },
                        remove: {
                            altLabel: 'Retirer cette règle de contenu.'
                        }
                    }
                },
                targeting: {
                    title: 'Vos cibles'
                },
                thematics: {
                    title: 'Vos thématiques éditoriales',
                    fields: {
                        defaultPostType: 'Type de post par défault'
                    },
                    defaultPostTypes: {
                        singleType: 'Fixe',
                        carousel: 'Carrousel',
                        undefined: 'Mix'
                    }
                }
            }
        },

        fileRepository: {
            form: {
                error: 'Une erreur s\'est produite pendant l\'enregistrement du fichier.',
                fields: {
                    file: 'Fichier',
                    legal: 'En cochant cette case, vous déclarez être propriétaire du fichier et acceptez qu\'il soit utilisé par des IA pour générer des contenus.',

                }
            }
        }
    },

    task: {
        list: {
            filters: {
                status: 'Statut',
                taskOrigin: 'Type de publication'
            }
        },
        agent: {
            transfert: {
                error: 'Une erreur s\'est produite pendant la mise à jour de la tâche.',
                fields: {
                    agent: 'Rechercher un agent',
                    submit: 'Transférer'
                }
            }
        },
        // Régénération de l'accroche
        regenerateHook: {
            error: 'Une erreur s\'est produite pendant le traitement de votre demande.',
            credits: '{ credits } crédits seront utilisés pour générer une nouvelle accroche.',
            fields: {
                subject: 'Sujet',
                marketingObjective: 'Objectif marketing',
                format: 'Format',
                tone: 'Ton',
                emoticonType: 'Avec ou sans émoji ?',
                prompt: 'Nouveau brief pour le sujet :'
            },
            placeholder: {
                prompt: 'Ex : "Génère une accroche en intégrant un exemple concret qui illustre le sujet du post" ou "Génère un texte plus long qui intègre des puces avec emojis pour structurer le post"' // 'Ex : "Retravaille cette accroche pour qu\'elle soit plus longue, avec seulement 2 emojis et sur un ton plus jovial." ou "Crées moi s\'il te plait une autre accroche textuelle avec les éléments" suivants : [ décrivez ici votre idée ]'
            }
        },
        // Régénération des médias
        regenerateMedias: {
            error: 'Une erreur s\'est produite pendant le traitement de votre demande.',
            credits: '{ credits } crédits seront utilisés pour générer de nouvelles images.',
            fields: {
                mediaPrompt: 'Décrivez en 1 phrase le visuel que vous souhaitez'
            },
            mediaPrompt: {
                description: 'Supprimez le prompte actuel si vous souhaitez entrer le vôtre, ou générez de nouvelles images en conservant le même prompte.'
            }
        },
        // Régénération complète
        regenerate: {
            error: 'Une erreur s\'est produite pendant le traitement de votre demande.',
            submit: {
                label: 'Régénérer'
            },
            fields: {
                subject: 'Titre du post', // 'Sujet',
                subjectDescription: 'Détails sur le post', // 'Description du sujet',
                marketingObjective: 'Objectif marketing',
                aiThematic: 'Thématique',
                aiAudience: 'Cible',
                format: 'Format',
                tone: 'Ton',
                emoticonType: 'Avec ou sans émoji ?',
                prompt: 'Prompte pour l\'IA', // 'Nouveau brief pour le sujet :',
                keywords: 'Mots clés',
                network: 'Réseau',
                mediaKeywords: 'Intégrer votre requête sous forme de mot-clé en anglais (3 max).'
            },
            tooltips: {
                subject: 'Thème général abordé pour le post.',
                subjectDescription: 'Décrivez les détails et informations importantes du post que vous souhaitez voir traités par l\'IA.',
                prompt: 'Indiquez vos instructions spécifiques afin que l\'IA en tienne compte. Par défaut, l\'IA garde en mémoire le texte généré précédemment, sauf si le titre du post a été modifié.'
            },
            aiSubject: {
                templates: {
                    label: 'Charte pour la publication'
                }
            },
            formats: {
                image: 'Crea fixe',
                carousel: 'Carrousel'
            },
            description: {
                mediaKeywords:  'Ex : "cat" ou "white" ou "garden"'
            }
        },
        // Mise à jour d'une donnée d'une donnée d'une tâche
        updateDatum: {
            error: 'Une erreur s\'est produite pendant la mise à jour des données.',
            fields: {
                publicationDate: 'Date de publication'
            }
        },
        // Création d'une tâche personnalisée
        createCustom: {
            error: 'Une erreur s\'est produite pendant la création de la tâche.',
            tabMenu: {
                customPublication: {
                    label: 'Tâche personnalisée',
                },
                events: {
                    label: 'A partir d\'un contenu'
                },
                aiSettings: {
                    label: 'Générez un post via un prompt'
                }
            },
            fields: {
                title: 'Titre du post',
                date: 'Date de la publication',
                networks: 'Réseaux sur lequel publier',
                network: 'Réseau',
                hook: 'Accroche',
                medias: 'Médias de la publication',
                mediasLegalAccepted: 'J\'ai les droits d\'utilisation de ces fichiers.'
            },
            addMedia: {
                button: {
                    label: 'Ajouter un média'
                }
            },
            mediasLegalAccepted: {
                description: 'En cochant cette case, vous déclarez avoir les droits sur ces fichiers et ne pas tenir { application } responsable en cas de conflit.'
            },
        },
        // Création en générant par l'IA
        createByAI: {
            error: 'Une erreur s\'est produite pendant la création de la tâche.',
            tabMenu: {
                settings: {
                    label: 'Paramètres',
                },
                events: {
                    label: 'Posts spécifiques'
                }
            },
            fields: {
                publicationDate: 'Date de publication'
            },
            requiredCredits: 'Votre quota de génération de { freeSubject } posts gratuit par mois a été atteint. { creditsBySubject } crédits par post supplémentaire sera utilisé pour générer vos posts soit { totalCredits } crédits pour cette demande.'
        },

        // Recherche d'informations pour la génération d'une tâche à partir de fichier
        searchInformationsWithFilesByIA: {
            error: 'Une erreur s\'est produite pendant l\'analyse des fichiers.',
            fields: {
                network: 'Réseau'
            },
            buttons: {
                addFile: {
                    label: 'Importez une image'
                }
            }
        },

        // Paramètre pour ne plus afficher le message d'information après l'ajout d'événements personnalisés
        updateDisplayMessageSettingAfterCustomEventsAdded: {
            error: 'Une erreur s\'est produite pendant la mise à jour de votre compte.',
            description: 'Vos posts sont en train d\'être générés, ils apparaitront sous peu dans votre planning avec la mention New.',
            fields: {
                setting: 'Ne plus afficher ce message'
            }
        },

        // Notation d'une tâche
        rating: {
            error: 'Une erreur s\'est produite pendant l\'enregistrement de votre avis.',
            fields: {
                briefingMatching: 'Compréhension de votre idée :',
                text: 'Qualité de l\'accroche :',
                visual: 'Qualité du visuel :',
                timing: 'Temps de réalisation :',
            },
            progressionLabels: {
                briefingMatching: {
                    low: 'Mauvaise',
                    hight: 'Bonne'
                },
                text: {
                    low: 'Mauvaise',
                    hight: 'Bonne'
                },
                visual: {
                    low: 'Mauvaise',
                    hight: 'Bonne'
                },
                timing: {
                    low: 'Mauvais',
                    hight: 'Bon'
                }
            },
            submit: {
                label: 'Enregistrer l\'avis'
            }
        },
        // Validation d'une tâche
        validate: {
            fields: {
                publishNow: 'Publier maintenant',
                schedule: 'Programmer',
                isStory: 'Publier en story',
                isFeed: 'Publier dans le feed'
            },
            submit: {
                save: {
                    label: 'Sauvegarder'
                }
            }
        },

        addComment: {
            error: 'Une erreur s\'est produite pendant l\'enregistrement de votre commentaire.',
            fields: {
                message: 'Commentaire',
                requestValidation: 'Demander une validation',
                validate: 'Valider',
                submit: 'Commenter'
            },
            placeholder: {
                comment: {
                    hook: 'Renseignez ici tout commentaire de modification souhaitée sur la légende du post puis cliquez sur "Valider" pour notifier votre agence.',
                    visual: 'Renseignez ici tout commentaire de modification souhaitée sur le visuel du post puis cliquez sur "Valider" pour notifier votre agence.',
                }
            },
            button: {
                validate: {
                    hook: {
                        label: 'Valider la légende'
                    },
                    visual: {
                        label: 'Valider le visuel'
                    }
                }
            }
        }
    },

    agency: {
        customer: {
            error: 'Une erreur s\'est produite pendant l\'enregistrement des données.',
            fields: {
                societyName: 'Nom de l\'entreprise',
                email: 'Email client utilisé pour créer le compte'
            },
            add: {
                title: 'Ajouter un client'
            },
            enable: {
                error: 'Une erreur s\'est produite pendant l\'activation du compte.'
            },
            edit: {
                error: 'Une erreur s\'est produite pendant la mise à jour du compte.',
                fields: {
                    role: 'Rôle',
                    automaticVisibleTasks: 'Publications automatiquement affichées au client'
                }
            }
        },
        affiliationCodes: {
            error: 'Une erreur s\'est produite pendant l\'enregistrement des données.',
            informations: 'Par défaut, si vous ne transmettez aucun code d\'affiliation à votre client et qu\'il s\'abonne sur la plateforme avec le même email, vous bénéficiez automatiquement de 20% de rémunération et 0% pour le client. Ou alors, créez un code d\'affiliation pour transmettre une réduction à votre client :',
            fields: {
                code: 'Nom du code d\'affiliation',
                agencyRemuneration: 'Valeur rémunération agence',
                customerPromotion: 'Valeur avantage client'
            }
        }
    },

    publication: {
        comments: {
            add: {
                error: 'Une erreur s\'est produite pendant l\'enregistrement de votre commentaire.',
                fields: {
                    message: 'Répondre à ce commentaire',
                    submit: 'Commenter'
                },
            },
            generateByAi: {
                error: 'Une erreur s\'est pendant la génération du commentaire avec l\'IA.',
                button: {
                    generate: {
                        label: 'Générer par l\'IA'
                    }
                }
            }
        }
    }

};
